<template>
  <div v-if="isLoading" class="text-center">
    <p>Chargement en cours...</p>
  </div>
  <div v-else class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Modifier un étudiant</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="etudiantForm" @submit="editEtudiant" :validation-schema="etudiantSchema"
        :initial-values="initialValues">
        <div class="row">
          <!-- Nom -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom de l'étudiant <span class="text-danger">*</span>
              </label>
              <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nom" />
              <ErrorMessage name="nom" class="text-danger" />
            </div>
          </div>

          <!-- Prénom -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Prénom de l' étudiant <span class="text-danger">*</span>
              </label>
              <Field name="prenom" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le prenom" />
              <ErrorMessage name="prenom" class="text-danger" />
            </div>
          </div>

          <!-- Email -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Email <span class="text-danger">*</span>
              </label>
              <Field name="email" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer l'email" />
              <ErrorMessage name="email" class="text-danger" />
            </div>
          </div>

          <!-- Sexe -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Sexe <span class="text-danger">*</span>
              </label>
              <Field name="sexe" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="['Masculin', 'Féminin']" v-model="field.value" v-bind="field"
                  placeholder="Sélectionner le sexe" />
              </Field>
              <ErrorMessage name="sexe" class="text-danger" />
            </div>
          </div>

          <!-- Téléphone 1 -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Téléphone 1 <span class="text-danger">*</span>
              </label>
              <Field name="telephone1" v-slot="{ field }">
                <vue-tel-input :value="field.value || ''" @input="field.onChange($event)" defaultCountry="BJ"
                  mode="international" @validate="validate" class="shadow-none fs-md-15 text-black py-2"
                  placeholder="Entrer le numéro de téléphone" />
              </Field>
              <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correct</div>
              <ErrorMessage name="telephone1" class="text-danger" />
            </div>
          </div>

          <!-- Date de naissance -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de naissance
              </label>
              <Field name="dateNaissance" type="date" :max="currentDate"
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="dateNaissance" class="text-danger" />
            </div>
          </div>

          <!-- Nationalité -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Pays de naissance <span class="text-danger">*</span>
              </label>
              <Field name="nationalite" v-slot="{ field }">
                <Multiselect :options="countries" :searchable="true" track-by="value" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner le pays de naissance" />
              </Field>
              <ErrorMessage name="nationalite" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Catégorie d'étudiant <span class="text-danger">*</span>
              </label>

              <Field name="categorieEtudiant" v-slot="{ field }">
                <Multiselect
                  :options="categorieEtudiantOptions"
                  track-by="value"
                  label="label"
                  :reduce="option => option.value"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionner la catégorie"
                />
              </Field>

              <ErrorMessage name="categorieEtudiant" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Formateur ?
              </label>

              <Field name="categorieFormateur" v-slot="{ field }">
                <Multiselect
                  :options="categorieFormateurOptions"
                  track-by="value"
                  label="label"
                  :reduce="option => option.value"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionner la catégorie"
                />
              </Field>

              <ErrorMessage name="categorieFormateur" class="text-danger" />
            </div>
          </div>


          <!-- Commune -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Commune <span class="text-danger">*</span>
              </label>
              <Field name="commune">
                <Multiselect :options="communeOptions" v-model="selectedCommune" @change="communeChange"
                  track-by="value" label="label" placeholder="Sélectionner la commune" />
              </Field>

              <ErrorMessage name="commune" class="text-danger" />
            </div>
          </div>

          <!-- Quartier -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Quartier <span class="text-danger">*</span>
              </label>
              <Field name="quartier">
                <Multiselect :options="quartierOptions" v-model="selectedQuartier" track-by="value" label="label"
                  placeholder="Sélectionner le quartier" noOptionsText="Sélectionner d'abord une commune" />
              </Field>

              <ErrorMessage name="quartier" class="text-danger" />
            </div>
          </div>

          <!-- Années d'expérience -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nombre d'années d'expériences
              </label>
              <Field name="anneeExperience" type="number" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nombre" />
              <ErrorMessage name="anneeExperience" class="text-danger" />
            </div>
          </div>


          <!-- Qualification -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Qualification <span class="text-danger">*</span>
              </label>
              <Field name="qualification" v-slot="{ field }">
                <Multiselect :options="qualificationOptions" :searchable="true" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner la qualification" />
              </Field>
              <ErrorMessage name="qualification" class="text-danger" />
            </div>
          </div>
          <!-- Activités -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Activité <span class="text-danger">*</span>
              </label>
              <Field name="activites" v-slot="{ field }">
                <Multiselect :options="activiteOptions" :searchable="true" mode="tags" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner l'activité" />
              </Field>
              <ErrorMessage name="activites" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Langue <span class="text-danger">*</span>
              </label>
              <Field name="langues" v-slot="{ field }">
                <Multiselect :options="languesOptions" :searchable="true" mode="tags" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner les langues" />
              </Field>
            </div>
            <ErrorMessage name="langues" class="text-danger" />
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Poste occupé actuellement
              </label>
              <Field name="poste" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le poste" />
              <ErrorMessage name="poste" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Catégorie Profesionnelle
              </label>
              <Field name="categorie" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer la categorie" />
              <ErrorMessage name="categorie" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Informations complémentaires <span class="text-danger">*</span>
              </label>
              <Field name="biographie" rows="2" as="textarea" placeholder="Ajouter d'autres informations"
                v-slot="{ field }" class="form-control shadow-none rounded-0 text-black">
                <textarea v-model="field.value" class="form-control shadow-none rounded-0 text-black"></textarea>
              </Field>
              <ErrorMessage name="biographie" class="text-danger" />
            </div>
          </div>

          <!-- Boutons -->
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button ref="submitButton" class="btn btn-success me-3" type="submit">
                Modifier l'étudiant
              </button>
              <router-link to="/liste-etudiants" class="btn btn-danger">
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { useRouter, useRoute } from 'vue-router';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect';
import { VueTelInput } from 'vue3-tel-input';
import { success, error } from '@/utils/utils';
import { countries } from '../../components/Inscription/countries';
import axios from 'axios';

export default defineComponent({
  name: 'EditEtudiant',
  components: { Form, Field, ErrorMessage, Multiselect, VueTelInput },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(true);
    const currentDate = ref(new Date().toISOString().split('T')[0]);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const validPhone = ref<boolean>(true);
    const initialValues = ref<any>({});
    const nationalite = ref('Bénin');

    const languesOptions = ref([]);

    const qualificationOptions = ref([]);
    const activiteOptions = ref([]);
    const communeOptions = ref([]);
    const quartierOptions = ref([]);
    const selectedCommune = ref<number | null>(null);
    const selectedQuartier = ref<number | null>(null);
    const categorieEtudiantOptions = ref([
      { value: 'Habitué', label: 'Habitué' },
      { value: 'Auditeur', label: 'Auditeur' },
      { value: 'Disciple', label: 'Disciple' },
      { value: 'Apprenant', label: 'Apprenant' },
    ]);

    const categorieFormateurOptions = ref([
      { value: 'Tutorat', label: 'Tutorat' },
      { value: 'Animateur', label: 'Animateur' },
    ]);
  


    const etudiantSchema = Yup.object().shape({
      nom: Yup.string().required('Le nom du étudiant est obligatoire'),
      prenom: Yup.string().required('Le prénom du étudiant est obligatoire'),
      sexe: Yup.string().required('Le sexe est obligatoire'),
      npi: Yup.string()
        .matches(/^\d{10}$/, 'La saisie doit avoir exactement 10 chiffres')
        .notRequired(),
      ifu: Yup.string()
        .matches(/^\d{13}$/, 'La saisie doit avoir exactement 13 chiffres')
        .notRequired(),
      email: Yup.string().email('Veuillez entrer un mail valide').notRequired(),
      telephone1: Yup.string().required('Le téléphone 1 est obligatoire'),
      categorieEtudiant: Yup.string()
      .required("La catégorie d'étudiant est obligatoire"),

      categorieFormateur: Yup.string()
        .nullable()
        .notRequired(),


      dateNaissance: Yup.date()
        .notRequired()
        .max(new Date(), 'La date de naissance ne peut pas être dans le futur')
        .test(
          'age-minimum',
          'Le étudiant doit avoir au moins 18 ans',
          function (value) {
            if (!value) return false;
            const today = new Date();
            const birthDate = new Date(value);
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            return age >= 18;
          }
        ),
      biographie: Yup.string().required("La biographie est obligatoire"),
      categorie: Yup.string()
        .notRequired(),
      poste: Yup.string()
        .notRequired(),
      langues: Yup.array()
        .of(Yup.string().required())
        .min(1, 'Au moins une langue est obligatoire'),
      nationalite: Yup.string().required('La nationalité est obligatoire'),
      commune: Yup.number().required('La commune est obligatoire'),
      quartier: Yup.number().required('Le quartier est obligatoire'),
      anneeExperience: Yup.number().notRequired(),
      qualification: Yup.number().required('La qualification est obligatoire'),
      activites: Yup.array()
        .of(Yup.string().required())
        .min(1, 'Au moins une activité est obligatoire'),
    });

    const validate = (phoneObject: any) => {
      validPhone.value = phoneObject.valid ?? true;
    };

    const fetchCommunes = async () => {
      try {
        const { data } = await ApiService.get('/communes');
        console.log('Communes:', data.data);
        communeOptions.value = data.data.data.map((item: any) => ({
          value: item.id,
          label: item.libelle,
        }));
      } catch (err) {
        console.error('Erreur lors du chargement des communes:', err);
        error('Erreur lors du chargement des communes');
      }
    };

    const communeChange = async (value: number | null) => {
      quartierOptions.value = [];
      selectedQuartier.value = null;

      if (value !== null) {
        try {
          const { data } = await ApiService.get(`/communes/quartiers/${value}`);
          quartierOptions.value = data.data.map((quartier: any) => ({
            value: quartier.id,
            label: quartier.libelle,
          }));
        } catch (err) {
          console.error('Erreur lors du chargement des quartiers:', err);
          error('Erreur lors du chargement des quartiers');
        }
      }
    };


    const fetchLangue = async () => {
      try {
        const { data } = await ApiService.get('/langues');
        console.log('Languesdf:', data.data.data);
        languesOptions.value = data.data.data.map((langue: any) => ({
          value: langue.id,
          label: langue.libelle,
        }));
      } catch (err) {
        console.error('Erreur lors du chargement des langues:', err);
        error('Erreur lors du chargement des langues');
      }
    };


    const fetchQualification = async () => {
      try {
        const { data } = await ApiService.get('/all/qualifications');
        console.log('Qualifications:', data.data.data);
        qualificationOptions.value = data.data.data.map((qualification: any) => ({
          value: qualification.id,
          label: qualification.libelle,
        }));
      } catch (err) {
        console.error('Erreur lors du chargement des qualifications:', err);
        error('Erreur lors du chargement des qualifications');
      }
    };

    const fetchActivite = async () => {
      try {
        const { data } = await ApiService.get('/activites');
        console.log('Activités:', data.data.data);
        activiteOptions.value = data.data.data.map((activite: any) => ({
          value: activite.id,
          label: activite.libelle,
        }));
      } catch (err) {
        console.error('Erreur lors du chargement des activités:', err);
        error('Erreur lors du chargement des activités');
      }
    };


    const getEtudiant = async (id: number) => {
      try {
        const { data } = await ApiService.get(`/etudiants/${id}`);
        console.log('Données du étudiant:', data.data);


        const etudiantData = data.data;
        console.log("Réponse brute étudiant :", JSON.stringify(etudiantData, null, 2));


        initialValues.value = {
          nom: etudiantData.nom || '',
          prenom: etudiantData.prenom || '',
          email: etudiantData.email || '',
          sexe: etudiantData.sexe || '',
          telephone1: etudiantData.telephone1 || etudiantData.user?.telephone || '', // ← attention au nom du champ
          dateNaissance: etudiantData.dateNaissance ? etudiantData.dateNaissance.split('T')[0] : '',
          biographie: etudiantData.biographie || '',
          categorie: etudiantData.categorie || '',
          poste: etudiantData.poste || '',
          anneeExperience: etudiantData.anneeExperience || null,
          nationalite: etudiantData.nationalite || 'Bénin',
          categorieEtudiant: etudiantData.categorieEtudiant || null,
          categorieFormateur: etudiantData.categorieFormateur || null,
          qualification: etudiantData.qualification?.id || null,
          commune: etudiantData.quartier?.arrondissement?.commune?.id
            || etudiantData.quartier?.commune?.id
            || null,

          quartier: etudiantData.quartier?.id || null,

          // Activités
          activites: etudiantData.userActivites?.map((ua: any) => ua.activite?.id).filter(Boolean)
            || etudiantData.activites?.map((a: any) => a.id).filter(Boolean)
            || [],


          // Langues — essaie plusieurs chemins possibles
          langues: etudiantData.langues
            || etudiantData.user?.langues?.map((l: any) => l.id).filter(Boolean)
            || etudiantData.user?.userLangues?.map((ul: any) => ul.langue?.id).filter(Boolean)
            || [],
        };

        // Debug très important
        console.log(" Valeurs extraites pour multiselect :", {
          activites: initialValues.value.activites,
          langues: initialValues.value.langues,
          raw_userActivites: etudiantData.userActivites,
          raw_langues: etudiantData.langues || etudiantData.user?.userLangues?.langues,
        });





        console.log('initialValues:', initialValues.value);
        console.log('commune vvr:', etudiantData.quartier?.commune);
        console.log('arrondisement:', initialValues.value.quartier?.commune);
        console.log('commufffffffffffffffffffne:', initialValues.value.commune);

        if (etudiantData.quartier?.arrondissement?.commune?.id) {

          await communeChange(etudiantData.quartier.arrondissement.commune.id);
          initialValues.value.commune = etudiantData.quartier.arrondissement.commune.id;
          selectedQuartier.value = etudiantData.quartier.id;


        }

      } catch (err: any) {
        console.error('Erreur lors du chargement du étudiant:', err);
        error(err.response?.data?.message || 'Erreur lors du chargement du étudiant');
      }
    };

    const editEtudiant = async (values: any, { resetForm }: any) => {

      if (submitButton.value) submitButton.value.disabled = true;
      try {
        const id = route.params.id;
        values.commune = selectedCommune.value;
        values.quartier = selectedQuartier.value;

        await ApiService.put(`/etudiants/${id}`, values);

        success('Etudiant modifié avec succès');
        resetForm();
        router.push({ name: 'ListeEtudiantPage' });
      } catch (err: any) {
        if (submitButton.value) submitButton.value.disabled = false;
        console.error('Erreur lors de la modification:', err);
        error(err.response?.data?.message || 'Erreur lors de la modification du étudiant');
      }
    };

    onMounted(async () => {
      isLoading.value = true;
      console.log('ID from route:', route.params.id);
      await Promise.all([
        fetchCommunes(),

        fetchLangue(),
        fetchQualification(),
        fetchActivite(),
      ]);
      if (route.params.id) {
        await getEtudiant(parseInt(route.params.id as string));

        // Après le chargement du étudiant
        selectedCommune.value = initialValues.value.commune;
        await communeChange(selectedCommune.value); // Charger les quartiers

        selectedQuartier.value = initialValues.value.quartier;
      }

      isLoading.value = false;
    });

    return {
      isLoading,
      etudiantSchema,
      initialValues,
      editEtudiant,
      currentDate,
      submitButton,
      validate,
      nationalite,
      countries,
      validPhone,
      communeOptions,
      quartierOptions,
      communeChange, selectedCommune,
      selectedQuartier,
      qualificationOptions, languesOptions,
      activiteOptions,
      categorieEtudiantOptions,
      categorieFormateurOptions
    };
  },
});
</script>